<template>
  <table class="table text-center table-border-color-override w-full" :class="`queue-status-item queue-status-${$queueHelper.getColorByStatus(extension.status)}`">
    <thead>
      <tr>
        <th class="mb-0 text-center" style="border-right: 0px;" @click.prevent="$emit('listen', extension.extension)">
          <vx-tooltip :text="$t('listen')" position="bottom">
            <img src="@/assets/images/listen.png" :class="{ 'active-cti-status-button': this.state.listen === true &&  this.state.currentNumber === extension.extension}" style="width: 32px;display: inline;cursor:pointer;">
          </vx-tooltip>
        </th>
        <th style="border-left: 0px;border-right: 0px; position: relative">
          <div v-if="extension.displayInOrOut == true" :class="`in-and-out-container ${extension.inOrOut.toLowerCase()}-design`" v-text="extension.inOrOut"></div>
          <h6 class="mb-0 text-center" v-text="extension.extension"></h6>
        </th>
        <th class="mb-0 text-center" style="border-left: 0px;" @click.prevent="$emit('whisper', extension.extension)">
          <vx-tooltip :text="$t('whisper')" position="bottom">
            <img src="@/assets/images/whisper.png" :class="{ 'active-cti-status-button': this.state.whisper === true &&  this.state.currentNumber === extension.extension}" style="width: 32px;display: inline;cursor:pointer;">
          </vx-tooltip>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td colspan="3">
          <p class="mb-1" :class="`callstatus-${extension.status}-text`" v-html="(extension.text != null && extension.text.length > 0) ? (extension.status === '4') ? '연결 안됨' : extension.text : '--'"></p>
          <p class="mb-1" v-html="extension.name != null && extension.name.length > 0 ? extension.name : '--'"></p>
          <p v-html="extension.time" class="mb-0"></p>
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr>
        <td colspan="3">
          <vs-button
            class="text-white"
            color="success"
            type="filled"
            @click.prevent="$emit('enable')"
            v-if="!extension.enabled"
            v-text="$t('enable')"
            size="small">
          </vs-button>

          <vs-button
            class="text-white"
            color="danger"
            type="filled"
            @click.prevent="$emit('disable')"
            v-else
            v-text="$t('disable')"
            size="small">
          </vs-button>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import QueueExtensionMixin from '@/mixins/queueExtensionMixin'

export default {
  name: 'Shared.Queues.Extensions.Card',
  mixins: [QueueExtensionMixin],
  props: {
    state: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/user/_variables.scss";

.queue-status-item {
  margin-bottom: 2rem;
}

table {
  &.table-border-color-override {
    &.queue-status-default, &.queue-status-rest, &.queue-status-lunch, &.queue-status-after, &.queue-status-consultation-available {
      thead,
      tbody,
      tfoot {
        * {
          border-color: $default-color;
          &:not(button) {
            color: $default-color;
          }
        }
        button {
          background-color: $default-color !important
        }
        .vs-button-success.vs-button-filled:hover {
            -webkit-box-shadow: 0 8px 25px -8px rgba($default-color,1) !important;
            box-shadow: 0 8px 25px -8px rgba($default-color,1) !important;
        }
      }
    }
    &.queue-status-busy {
      thead,
      tbody,
      tfoot {
        * {
          border-color: $busy-color;
          &:not(button) {
            color: $busy-color;
          }
        }
        button {
          background-color: $busy-color !important
        }
        .vs-button-success.vs-button-filled:hover {
            -webkit-box-shadow: 0 8px 25px -8px rgba($busy-color,1) !important;
            box-shadow: 0 8px 25px -8px rgba($busy-color,1) !important;
        }
      }
    }
    &.queue-status-logout {
      thead,
      tbody,
      tfoot {
        * {
          border-color: $logout-color !important;
          &:not(button) {
            color: $logout-color;
          }
        }
        button {
          background-color: $logout-color !important
        }
        .vs-button-success.vs-button-filled:hover {
            -webkit-box-shadow: 0 8px 25px -8px rgba($logout-color,1) !important;
            box-shadow: 0 8px 25px -8px rgba($logout-color,1) !important;
        }
      }
    }
    &.queue-status-ringing {
      thead,
      tbody,
      tfoot {
        * {
          border-color: $ringing-color !important;
          &:not(button) {
            color: $ringing-color;
          }
        }
        button {
          background-color: $ringing-color !important
        }
        .vs-button-success.vs-button-filled:hover {
            -webkit-box-shadow: 0 8px 25px -8px rgba($ringing-color,1) !important;
            box-shadow: 0 8px 25px -8px rgba($ringing-color,1) !important;
        }
      }
    }
  }
}
table {
  &.table-border-color-override {
    .out-design {
      border-color: blue !important;
      color: blue !important;
    }
    .in-design {
      border-color: red !important;
      color: red !important;
    }
  }
}

.in-and-out-container {
  position: absolute;
  top: -16px;
  padding: 6px 3px;
  left: calc(50% - 15px);
  background-color: white;
  border: solid 1px;
  border-radius: 50%;
  font-size: 10px;
  min-width: 30px;
  text-align: center;
}
</style>
